var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('map-google',{staticClass:"pc-map"}),_c('map-googlewap',{staticClass:"wap-map"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }